
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as empty5o9wmgK1bI42GxsazpR6zXUuFFabmM5tbtuCPvVgsS0Meta } from "/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/pages/empty.vue?macro=true";
import { default as eventsN2XsniHg8MVAD7NKN7eD9r6a9u9sTCCJ8jZ5KBFVFwgMeta } from "/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/pages/events.vue?macro=true";
import { default as searchFqMgnbEIknaczaXyEZTy6nHjFeVgfpHygLAq08s8fkQMeta } from "/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/pages/search.vue?macro=true";
import { default as default9j_20OoI1_45u8nc8Vv5bjrik_gU02JMXW6IF_45XmqsmpQMeta } from "/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/pages/default.vue?macro=true";
import { default as winkelmand8UZtem6EMkFkhzevBA9Dg_eSBnVel8JFxO1ziuQknDMMeta } from "/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/pages/winkelmand.vue?macro=true";
import { default as koop_45kaarten6VWy_45ie9tr0ElTtkfS2SfZMhKSSZr9yEMnRw_45_IvC40Meta } from "/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/pages/koop-kaarten.vue?macro=true";
export default [
  {
    name: "empty",
    path: "/empty",
    component: () => import("/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/pages/empty.vue")
  },
  {
    name: "events",
    path: "/events",
    meta: eventsN2XsniHg8MVAD7NKN7eD9r6a9u9sTCCJ8jZ5KBFVFwgMeta || {},
    alias: ["/en/events/:slug","/nl/events/:slug"],
    component: () => import("/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/pages/events.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/pages/search.vue")
  },
  {
    name: "default",
    path: "/default",
    component: () => import("/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/pages/default.vue")
  },
  {
    name: "winkelmand",
    path: "/winkelmand",
    component: () => import("/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/pages/winkelmand.vue")
  },
  {
    name: "koop-kaarten",
    path: "/koop-kaarten",
    component: () => import("/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/pages/koop-kaarten.vue")
  }
]